import React, { useEffect, useState } from 'react';
import {Grid} from "@mui/material";
import PortfolioBalance from 'app/shared/metrics/PortfolioBalance/PortfolioBalance';
import EarningExpenses from 'app/shared/metrics/EarningExpenses/EarningExpenses';
import MarketingCampaign from 'app/shared/widgets/MarketingCampaign/MarketingCampaign';
import ObjectCountRevenue from "../../../shared/metrics/ObjectCountCards/ObjectCountRevenue";
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';
import RedeemIcon from '@mui/icons-material/Redeem';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Referralusers from 'app/shared/widgets/ReferralUsers/ReferralUsers';
import { dashboard,roidata, referralusers, dashboardtransactions } from 'backendServices/ApiCalls';
import { useContext } from 'react';
import { CustomProvider } from 'app/layouts/vertical-default/VerticalDefault';

const Crypto = () => {
    const [userroidata,setUserRoiData]=useState([])
    const [dashboarddata,setDashboardData]=useState([])
    const [lasttransactionsdata,setLastTransactionsData]=useState([])
    const [picturelink,setPictureLink]=useState([])
    const [referralusersdata,setReferralUsersData]=useState([])
    
    const {loginUserData} = useContext(CustomProvider);
    let userData = loginUserData


    const DashboardData =()=>{
        dashboard((response) => {
            setDashboardData(response?.data?.data)
        }, (error) => {
            console.log(error?.response?.data);
        })
    }

    const RoiData =()=>{
        roidata((response) => {
            setUserRoiData(response?.data?.data)
        }, (error) => {
            console.log(error?.response?.data);
        })
    }
    const TransactionData =()=>{
        dashboardtransactions((response) => {
            setLastTransactionsData(response?.data?.data?.enteries)
        }, (error) => {
            console.log(error?.response?.data);
        })
    }
    console.log("lasttransactionsdata",lasttransactionsdata)

    const ReferralUsers =()=>{
        referralusers((response) => {
            setReferralUsersData(response?.data?.data?.enteries)
            setPictureLink(response?.data?.data?.picturelink)
        }, (error) => {
            console.log(error.response.data);
        })
    } 
    
    

    useEffect(()=>{
        RoiData();
        ReferralUsers();
        TransactionData();
        DashboardData();
    },[])
    const totalUsers = +(dashboarddata?.inactiveusers || 0) + +(dashboarddata?.activeusers || 0);




    if(userData.firstname === "")
    {

        return <div>loading</div>
    }

    return (
        <Grid container spacing={3.75}>
             <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.deposit || 0} title='tdeposit' color="secondary.main"  icon={<AccountBalanceWalletRoundedIcon fontSize='large'/>}  vertical={true}/>
            </Grid>
             <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.payout || 0} title='tpayout' color="success.main"  icon={<RedeemIcon fontSize='large'/>}  vertical={true}/>
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.roi || 0} title='totalroi' color="success.main"  icon={<RedeemIcon fontSize='large'/>}  vertical={true}/>
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.referralbonus || 0} title='referralbonus' color="primary.main" icon={<AccountBalanceWalletRoundedIcon fontSize='large'/>} vertical={true}/>
            </Grid>
            
            <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.unilevelbonus || 0} title='unilevelbonus' color="info.main"  icon={<GroupAddIcon fontSize='large'/>}  vertical={true}/>
            </Grid> 
            <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.activeusers || 0} title='activeusers' color="info.main"  icon={<GroupAddIcon fontSize='large'/>}  vertical={true}/>
            </Grid> 
            <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={dashboarddata?.inactiveusers || 0} title='inactiveusers' color="info.main"  icon={<GroupAddIcon fontSize='large'/>}  vertical={true}/>
            </Grid> 
            <Grid item xs={12} sm={6} lg={3}>
                <ObjectCountRevenue value={totalUsers} title='tusers' color="info.main"  icon={<GroupAddIcon fontSize='large'/>}  vertical={true}/>
            </Grid> 
            <Grid item xs={12} lg={12}>
                <MarketingCampaign lasttransactionsdata={lasttransactionsdata}/>
            </Grid>
        </Grid>
    );
};

export default Crypto;
